<template>
  <tr class="title" v-show="!editType">
    <th :colspan="cardObject.column">
      <span :style="{ 'pointer-events': cardObject.canEdit ? 'auto' : 'none' }">
        <span class="title-text">{{ title }}</span>
        <span class="edit-icon" v-if="cardObject.canEdit" @click="tableEdit" />
      </span>
    </th>
  </tr>
</template>
<script>
export default {
  name: 'table-caption',
  methods: {
    tableEdit () {
      this.$emit('update:editType', !this.editType)
      this.$nextTick(() => {
        this.cardObject.setEditTypeAll(this.editType)
        if (!this.editType) this.cardObject.resetEditValueAll()
      })
    }
  },
  props: {
    editType: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    cardObject: {
      type: Object
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./main.scss";
.title {
  width: 1000px;
  height: $table-height;
  background: #f1f1f1;
  font-size: 22px;
  font-weight: 500;
  color: #4a4a4a;
  text-align: center;
  box-sizing: border-box;
  border-color: #9b9b9b;
  border-style: solid;
  border-width: 1px 1px 0 1px;
  cursor: context-menu;
  user-select: none;
  img {
    height: 20px;
    width: 20px;
    margin-left: 15px;
    position: relative;
    top: 3px;
    cursor: pointer;
  }
  span {
    display: inline-block;
    height: $table-height;
    line-height: $table-height;
    width: 100%;
    transition: all 0.3s;
    .title-text {
      width: max-content;
      letter-spacing: 15px;
      pointer-events: none;
    }
    &:hover {
      background: rgba(0, 122, 255, 0.1);
      .edit-icon {
        background-image: url(../../../../../../assets/card-edit.svg);
      }
    }
    .edit-icon {
      cursor: pointer;
      display: inline-block;
      height: 20px;
      width: 20px;
      position: relative;
      top: 3px;
      left: -7px;
      background-image: url(../../../../../../assets/card-edit-disabled.svg);
    }
  }
  .disabled {
    background: rgba(0, 122, 255, 0.1);
    .edit-icon {
      background-image: url(../../../../../../assets/card-edit.svg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/student-status-card/components/StatusCard/components/CCaption.vue